var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header"},[_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }